import { v4 as uuidv4 } from 'uuid';

const CORS_PROXY = 'https://corsproxy.io/?';

// FIX: Wir nutzen 'rest-prod' (Bindestrich) statt 'rest.prod' (Punkt).
// 'rest.prod' verursacht SSL-Fehler (526) bei Proxies.
// Der Inhalt/Payload bleibt aber identisch zur Node-Library (v4 API).
const BASE_URL = 'https://rest-prod.immedia-semi.com';

const APP_VERSION = "6.10.0"; 

const HEADERS = {
  'Content-Type': 'application/json',
  // Wichtig: Kein strenger User-Agent, da wir die v4 API emulieren
};

export const blinkService = {
  async login(email, password) {
    let deviceId = localStorage.getItem('blink_device_id');
    if (!deviceId) {
        deviceId = uuidv4();
        localStorage.setItem('blink_device_id', deviceId);
    }

    const payload = {
      email: email,
      password: password,
      client_specifier: "Node Blink Security | 0.5.0 | node | 16.0.0",
      client_type: "android",
      unique_id: deviceId,
      app_version: APP_VERSION
    };

    const url = `${CORS_PROXY}${encodeURIComponent(`${BASE_URL}/api/v4/account/login`)}`;
    console.log("Blink Login (v4 fix)...", url);

    const response = await fetch(url, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      console.error("Blink Error:", err);
      
      if (response.status === 526) {
         throw new Error('Verbindungsfehler (SSL 526). Der Proxy konnte Blink nicht erreichen. Bitte später versuchen.');
      }
      if (err.message && err.message.includes('Unauthorized')) {
         throw new Error('Email oder Passwort falsch.');
      }
      throw new Error(err.message || `Login fehlgeschlagen (Status ${response.status})`);
    }

    const data = await response.json();
    
    if (data.account && data.account.client && data.account.client.verification_required) {
      return {
        status: 'verification_required',
        accountId: data.account.id,
        clientId: data.account.client.id,
        authtoken: data.authtoken.authtoken,
        region: data.region ? (typeof data.region === 'object' ? Object.keys(data.region)[0] : data.region) : 'prod'
      };
    }

    return this._processLoginSuccess(data);
  },

  async verifyPin(accountId, clientId, authtoken, pin, regionKey) {
    const regionUrl = this._getRegionUrl(regionKey);
    const url = `${CORS_PROXY}${encodeURIComponent(`${regionUrl}/api/v4/account/${accountId}/client/${clientId}/pin/verify`)}`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: { ...HEADERS, 'token-auth': authtoken },
      body: JSON.stringify({ pin })
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || 'PIN Verifizierung fehlgeschlagen');
    }

    return {
      status: 'success',
      authtoken: authtoken,
      region: regionKey,
      accountId: accountId,
      clientId: clientId
    };
  },

  async getDashboard(auth) {
    const regionUrl = this._getRegionUrl(auth.region);
    const url = `${CORS_PROXY}${encodeURIComponent(`${regionUrl}/api/v3/accounts/${auth.accountId}/homescreen`)}`;
    
    const response = await fetch(url, {
      headers: { ...HEADERS, 'token-auth': auth.authtoken }
    });

    if (!response.ok) throw new Error('Konnte Dashboard nicht laden');
    return await response.json();
  },

  async setArmState(auth, networkId, state) {
    const regionUrl = this._getRegionUrl(auth.region);
    const url = `${CORS_PROXY}${encodeURIComponent(`${regionUrl}/api/v3/accounts/${auth.accountId}/networks/${networkId}/state/${state}`)}`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: { ...HEADERS, 'token-auth': auth.authtoken },
      body: JSON.stringify({})
    });

    if (!response.ok) throw new Error(`Konnte System nicht ${state === 'arm' ? 'aktivieren' : 'deaktivieren'}`);
    return await response.json();
  },

  async getThumbnail(auth, fullUrl) {
    let targetUrl = fullUrl;
    if (!fullUrl.startsWith('http')) {
        const regionUrl = this._getRegionUrl(auth.region);
        targetUrl = `${regionUrl}${fullUrl}`;
    }
    if (!targetUrl.endsWith('.jpg')) targetUrl += '.jpg';

    const proxyUrl = `${CORS_PROXY}${encodeURIComponent(targetUrl)}`;

    const response = await fetch(proxyUrl, {
      headers: { ...HEADERS, 'token-auth': auth.authtoken }
    });

    if (!response.ok) throw new Error('Bild konnte nicht geladen werden');
    
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  },

  _processLoginSuccess(data) {
    let region = 'prod';
    if (data.region) {
        if (typeof data.region === 'object') {
            region = Object.keys(data.region)[0];
        } else {
            region = data.region;
        }
    }
    return {
      status: 'success',
      authtoken: data.authtoken.authtoken,
      region: region,
      accountId: data.account.id,
      clientId: data.account.client.id
    };
  },

  _getRegionUrl(regionKey) {
    const tier = (typeof regionKey === 'string' && regionKey) ? regionKey : 'prod';
    return `https://rest-${tier}.immedia-semi.com`;
  }
};